document.addEventListener("DOMContentLoaded", () => {
  const dialogs = document.querySelectorAll("dialog");

  dialogs.forEach((dialog, index) => {
    if (!dialog.id) {
      dialog.id = 'dialog-' + index;
    }

    const showButton = dialog.nextElementSibling;
    const closeButton = dialog.querySelector("button");

    // Mostrar el diálogo
    showButton.addEventListener("click", () => {
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });

    // Cerrar el diálogo
    const closeDialog = () => {
      dialog.close();
      document.body.style.overflow = 'auto';
    };

    closeButton.addEventListener("click", closeDialog);

    // Cerrar el diálogo al hacer clic en el backdrop
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog && dialog.open) {
        closeDialog();
      }
    });

    // Cerrar el diálogo al hacer clic en enlaces internos dentro del diálogo
    dialog.addEventListener("click", (event) => {
      if (event.target.tagName === 'A' && event.target.getAttribute('href')?.startsWith('#')) {
        closeDialog();
      }
    });
  });
});